const TOKEN_KEY = 'token'
const TOKEN_EXPIRE_KEY = 'tokenExpireAt'
/** 登录 token 有效期：24 小时 */
const TOKEN_TTL_MS = 24 * 60 * 60 * 1000

export function clearToken() {
  window.localStorage.removeItem(TOKEN_KEY)
  window.localStorage.removeItem(TOKEN_EXPIRE_KEY)
}

export function setToken(token) {
  if (!token) {
    clearToken()
    return
  }
  window.localStorage.setItem(TOKEN_KEY, String(token))
  window.localStorage.setItem(
    TOKEN_EXPIRE_KEY,
    String(Date.now() + TOKEN_TTL_MS)
  )
}

/**
 * 读取未过期的 token；过期或缺过期时间则清空并返回空
 */
export function getToken() {
  const token = window.localStorage.getItem(TOKEN_KEY)
  if (!token) {
    clearToken()
    return ''
  }
  const expireAt = Number(window.localStorage.getItem(TOKEN_EXPIRE_KEY))
  if (!expireAt || Number.isNaN(expireAt) || Date.now() > expireAt) {
    clearToken()
    return ''
  }
  return token
}

export function isTokenValid() {
  return !!getToken()
}



// WEBPACK FOOTER //
// ./src/utils/token.js